// extracted by mini-css-extract-plugin
export default {"container":"ptB1YeIRR7EqS9Fhqppd","content":"lNSjcXUvWsE8dDRSGGCU","total":"VFMWrFtvGqgVyHWRRdUx"};